import {Mapper} from '@s-ui/domain'

export class FromRawDataToGetConversationEntityUserMapper extends Mapper {
  constructor({config, conversationUserEntity, getConversationUserErrorFactory}) {
    super()
    this._config = config
    this._conversationUserEntity = conversationUserEntity
    this._getConversationUserErrorFactory = getConversationUserErrorFactory
  }

  _getConversationsByAd = ({adId, userConversations}) =>
    userConversations.filter(conversation => String(conversation.itemId) === String(adId))

  setParams = ({adId, partnerId}) => {
    this._adId = adId
    this._partnerId = partnerId

    return this
  }

  map = rawData => {
    const {
      _embedded: {conversations}
    } = rawData

    const conversationsByAd = this._getConversationsByAd({
      adId: this._adId,
      userConversations: conversations
    })

    if (!conversationsByAd.length) throw this._getConversationUserErrorFactory('No conversation found')

    const [currentConversation] = this._partnerId
      ? conversationsByAd.filter(conversation => String(conversation.partnerId) === String(this._partnerId))
      : conversationsByAd

    return this._conversationUserEntity({
      conversationId: currentConversation.conversationId
    })
  }
}
